var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureVirtualMachines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a44",
    x1: 8.88,
    y1: 12.21,
    x2: 8.88,
    y2: 0.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b44",
    x1: 8.88,
    y1: 16.84,
    x2: 8.88,
    y2: 12.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.12,
    y: 0.21,
    width: 18,
    height: 12,
    rx: 0.6,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M11.88 4.46v3.49l-3 1.76v-3.5l3-1.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3f1ff",
    d: "M11.88 4.46l-3 1.76-3-1.76 3-1.75 3 1.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cebff",
    d: "M8.88 6.22v3.49l-3-1.76V4.46l3 1.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3f1ff",
    d: "M5.88 7.95l3-1.74v3.5l-3-1.76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cebff",
    d: "M11.88 7.95l-3-1.74v3.5l3-1.76z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 15.84c-1.78-.28-1.85-1.56-1.85-3.63H7.11c0 2.07-.06 3.35-1.84 3.63a1 1 0 00-.89 1h9a1 1 0 00-.89-1z",
    fill: "url(#b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureVirtualMachines);
export default __webpack_public_path__ + "static/media/azure-virtualMachines.892c4f03ea63124963fc543f96f6d779.svg";
export { ForwardRef as ReactComponent };